// Detects free text that ends with a US state (abbreviation or full name), e.g. "Gulfport FL".
// Only the LAST token / phrase counts, so "Plan IN the park" is false.

const STATES = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
  FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois',
  IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
  ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
  MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
  NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
  NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon',
  PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota',
  TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia',
  WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
};

const ABBREVIATIONS = new Set(Object.keys(STATES));
const FULL_NAMES = Object.values(STATES).map((n) => n.toLowerCase());
// Abbreviations that are also common words (or other countries' codes): only count in UPPERCASE.
const AMBIGUOUS = new Set(['IN', 'OR', 'ME', 'OK', 'HI', 'AL', 'LA', 'PA', 'MA', 'MD', 'ID', 'DE', 'WA', 'WI']);
// Full names that are also well-known non-US places: a bare one is not enough.
const AMBIGUOUS_NAMES = new Set(['washington', 'georgia']);

export function looksLikeUSLocation(text) {
  if (typeof text !== 'string') return false;
  const t = text.trim().replace(/\s+/g, ' ');
  if (!t) return false;

  // Full state name at the end, preceded by a comma/space or nothing
  const lower = t.toLowerCase();
  for (const name of FULL_NAMES) {
    if (lower === name) { if (AMBIGUOUS_NAMES.has(name)) continue; return true; }
    if (lower.endsWith(` ${name}`) || lower.endsWith(`,${name}`)) return true;
  }

  // Abbreviation as the last token, preceded by a comma or space
  const m = t.match(/^(.*?)(,\s*|\s)([A-Za-z]{2})$/);
  if (!m) return false;
  const before = m[1].trim();
  const abbr = m[3].toUpperCase();
  if (!ABBREVIATIONS.has(abbr)) return false;
  if (!before) return false;
  if (AMBIGUOUS.has(abbr) && m[3] !== abbr) return false; // 'near me', 'Plan in' never match
  return true;
}
